"use client";
import { baseIcons } from "@/assets/icons";
import baseImages from "@/assets/images";
import Image from "next/image";

const LandingCurvedItemsSlider = () => {
  return (
    <>
      <div className="place-self-center grid grid-cols-2 lg:grid-cols-4 lg:gap-12 mb-4 w-full mt-12">
        {[
          {
            title: "ویدئو آموزشی",
            description:
              "با ویدیوهای کوتاه درس به درس، مطالب درسی را آسان و سریع یاد بگیرید.",
            img: baseIcons.curvedItemLandingIcon4,
          },
          {
            title: "خلاصه نکات",
            description:
              "با خلاصه نکات درس به درس، فقط به نکات مهم بپردازید و زمان را ذخیره کنید.",
            img: baseIcons.curvedItemLandingIcon3,
          },
          {
            title: "نمونه‌سوالات حل شده",
            description:
              "با نمونه سوالات حل شده درس به درس، مثال‌های مهم را ببینید و مفاهیم را آسان درک کنید.",
            img: baseIcons.curvedItemLandingIcon2,
          },
          {
            title: "دوره‌های آموزشی",
            description:
              "با دوره‌های آموزشی، وارد مسیر یادگیری شوید و خیال خود را از کل درس راحت کنید.",
            img: baseIcons.curvedItemLandingIcon1,
          },
        ].map(({ description, img, title }, i) => (
          <div
            key={i}
            className="relative w-full md:max-w-80 place-self-center mt-10"
          >
            <Image
              alt="ایتم های ست"
              src={baseImages.curvedItemLanding}
              width={400}
              className="h-auto w-full"
            />
            <div className="absolute w-[36%] -top-1/12 place-self-center">
              <div className="absolute w-full h-full place-items-center place-content-center">
                <Image
                  className="max-w-2/3 max-h-2/3"
                  alt="ایکن ایتم ها"
                  src={img}
                />
              </div>
              <div>
                <Image
                  alt="ایتم های ست"
                  src={baseImages.curvedCircleLanding}
                  width={200}
                />
              </div>
            </div>

            <div className="w-[80%] place-self-center absolute top-[44%] text-center">
              <h2 className="text-white text-[15px] text-nowrap md:text-[24px] font-bold md:mb-2">
                {title}
              </h2>
              <p className="text-wrap text-white md:text-[16px] text-[12px]">
                {description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default LandingCurvedItemsSlider;
